var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"webPageDoc"},[_c('el-main',{staticClass:"content"},[(_vm.webPage)?_c(_vm.webPage,{tag:"component",attrs:{"transferData":_vm.transferData}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }